import {
    ChevronLeft,
    ChevronRight,
    Copy,
    CreditCard,
    File,
    Home,
    LineChart,
    ListFilter,
    MoreVertical,
    Package,
    Package2,
    PanelLeft,
    Search,
    Settings,
    ShoppingCart,
    Truck,
    Users2,
} from "lucide-react";

import { Badge } from "../../comps/ui/badge";
import {
    Breadcrumb,
    BreadcrumbItem,
    BreadcrumbLink,
    BreadcrumbList,
    BreadcrumbPage,
    BreadcrumbSeparator,
} from "../../comps/ui/breadcrumb";
import { Button } from "../../comps/ui/button";
import {
    Card,
    CardContent,
    CardDescription,
    CardFooter,
    CardHeader,
    CardTitle,
} from "../../comps/ui/cards";
import {
    DropdownMenu,
    DropdownMenuCheckboxItem,
    DropdownMenuContent,
    DropdownMenuItem,
    DropdownMenuLabel,
    DropdownMenuSeparator,
    DropdownMenuTrigger,
} from "../../comps/ui/dropdown-menu";

import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    TableRow,
} from "../../comps/ui/table";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../comps/ui/tabs";
import { OrdersTable } from "../../comps/orders/orderstable";
import { Progress } from "../../comps/ui/progress";

export default function OrderPage() {
    // function getStartOfWeek(date: Date) {
    //     const dt = new Date(
    //         date.getFullYear(),
    //         date.getMonth(),
    //         date.getDate()
    //     );
    //     const offset = dt.getDate() - (dt.getDay() === 0 ? 6 : dt.getDay() - 1);
    //     return new Date(dt.setDate(offset));
    // }

    // function getStartOfMonth(date: Date) {
    //     return new Date(date.getFullYear(), date.getMonth(), 1);
    // }

    // function filterThisWeek(files: any[], referenceDate = new Date()) {
    //     const lowerThreshold = getStartOfWeek(referenceDate);
    //     return files.filter(
    //         (file: { date: Date }) => file.date >= lowerThreshold
    //     );
    // }

    // function filterThisMonth(files: any[], referenceDate = new Date()) {
    //     const lowerThreshold = getStartOfMonth(referenceDate);
    //     const upperThreshold = getStartOfWeek(referenceDate);
    //     return files.filter(
    //         (file: { date: Date }) =>
    //             file.date >= lowerThreshold && file.date < upperThreshold
    //     );
    // }

    // function formatFile(file: {
    //     date: { toLocaleDateString: (arg0: string) => any };
    // }) {
    //     return `${file.date.toLocaleDateString("sv")}`;
    // }

    // const testFiles = Array.from({ length: 14 }, (v, k) => {
    //     return { date: new Date(Date.now() - k * 86400 * 1000) };
    // });

    // console.log("This weeks files:", filterThisWeek(testFiles).map(formatFile));
    // console.log(
    //     "This months files:",
    //     filterThisMonth(testFiles).map(formatFile)
    // );
    return (
        <main className="flex p-4 sm:px-6 sm:py-0 md:gap-8">
            <Tabs defaultValue="week" className="w-full">
                <div className="flex items-center">
                    <TabsList>
                        <TabsTrigger value="week">Week</TabsTrigger>
                        <TabsTrigger value="month">Month</TabsTrigger>
                        <TabsTrigger value="year">Year</TabsTrigger>
                    </TabsList>
                    <div className="ml-auto flex items-center gap-2">
                        <DropdownMenu>
                            <DropdownMenuTrigger asChild>
                                <Button
                                    variant="outline"
                                    size="sm"
                                    className="h-7 gap-1 text-sm"
                                >
                                    <ListFilter className="h-3.5 w-3.5" />
                                    <span className="sr-only sm:not-sr-only">
                                        Filter
                                    </span>
                                </Button>
                            </DropdownMenuTrigger>
                            <DropdownMenuContent align="end">
                                <DropdownMenuLabel>Filter by</DropdownMenuLabel>
                                <DropdownMenuSeparator />
                                <DropdownMenuCheckboxItem checked>
                                    Fulfilled
                                </DropdownMenuCheckboxItem>
                                <DropdownMenuCheckboxItem>
                                    Declined
                                </DropdownMenuCheckboxItem>
                                <DropdownMenuCheckboxItem>
                                    Refunded
                                </DropdownMenuCheckboxItem>
                            </DropdownMenuContent>
                        </DropdownMenu>
                        <Button
                            size="sm"
                            variant="outline"
                            className="h-7 gap-1 text-sm"
                        >
                            <File className="h-3.5 w-3.5" />
                            <span className="sr-only sm:not-sr-only">
                                Export
                            </span>
                        </Button>
                    </div>
                </div>
                <TabsContent value="week">
                    <OrdersTable />
                </TabsContent>
            </Tabs>
            <div className="flex flex-col gap-4">
                <Card className="h-fit sm:col-span-2">
                    <CardHeader className="pb-3">
                        <CardTitle>Your Orders</CardTitle>
                        <CardDescription className="max-w-lg text-balance leading-relaxed">
                            Introducing Our Dynamic Orders Dashboard for
                            Seamless Management and Insightful Analysis.
                        </CardDescription>
                    </CardHeader>
                    <CardFooter>
                        <Button>Create New Order</Button>
                    </CardFooter>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardDescription>This Week</CardDescription>
                        <CardTitle className="text-4xl">₹ 1,329</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-xs text-muted-foreground">
                            +25% from last week
                        </div>
                    </CardContent>
                    <CardFooter>
                        <Progress value={25} aria-label="25% increase" />
                    </CardFooter>
                </Card>
                <Card>
                    <CardHeader className="pb-2">
                        <CardDescription>This Month</CardDescription>
                        <CardTitle className="text-4xl">₹ 5,329</CardTitle>
                    </CardHeader>
                    <CardContent>
                        <div className="text-xs text-muted-foreground">
                            +10% from last month
                        </div>
                    </CardContent>
                    <CardFooter>
                        <Progress value={12} aria-label="12% increase" />
                    </CardFooter>
                </Card>
            </div>
        </main>
    );
}
